import { reactive } from 'vue'

const toastState = reactive({
  visible: false,
  message: '',
  type: 'success'
})

let hideTimer = null

export const showToast = (message, type = 'success', duration = 3000) => {
  if (hideTimer) {
    window.clearTimeout(hideTimer)
  }

  toastState.message = message
  toastState.type = type
  toastState.visible = true

  hideTimer = window.setTimeout(() => {
    toastState.visible = false
  }, duration)
}

export const hideToast = () => {
  if (hideTimer) {
    window.clearTimeout(hideTimer)
    hideTimer = null
  }
  toastState.visible = false
}

export const useToast = () => ({
  toastState,
  showToast,
  hideToast
})
